/**
 * 导出默认网路配置
 *
 * @author Shigq
 * @date 2020/12/4 11:17
 */
const net = {
  gateway: {
    user: '/samp-server',
    // user: '',
    sccp: '/samp-server',
    file: '/samp-server'
  },
  httpCode: {
    // 操作正常code，支持String、Array、int多种类型
    success: [200, '000000'],
    // system error
    serviceUnavailable: [503],
    // token timeout
    movedTemporarily: [302],
    // auth deny
    unauthorized: [401],
    // file not found
    notFound: [404],
    // 认证信息失效
    identityPast: ['111110', '100004', '100011', 'GW0300'],
    // 未登录,
    unLogin: ['GW0302']
  }
}

module.exports = net
